import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import ChiSiamo from "./pages/ChiSiamo";
import Servizi from "./pages/Servizi";
import ComeFunziona from "./pages/ComeFunziona";
import Contatti from "./pages/Contatti";
import Supporto from "./pages/Supporto";
import Reclami from "./pages/Reclami";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/chi-siamo" element={<ChiSiamo />} />
            <Route path="/servizi" element={<Servizi />} />
            <Route path="/come-funziona" element={<ComeFunziona />} />
            <Route path="/contatti" element={<Contatti />} />
            <Route path="/supporto" element={<Supporto />} />
            <Route path="/reclami" element={<Reclami />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
